import React from 'react';

const FlushInactiveIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1433_13289)">
        <path
          d="M10.4191 8.69157C10.7667 8.69157 11.0788 8.91852 11.2108 9.24105H12.7811C12.865 9.24105 12.9373 9.31364 12.9373 9.3973V9.68376C12.9372 9.76734 12.865 9.8387 12.7811 9.8387L11.2108 9.85042C11.0909 10.1731 10.7788 10.3882 10.4191 10.3882C9.95179 10.388 9.56775 10.0063 9.56755 9.54053C9.56755 9.07455 9.95166 8.69178 10.4191 8.69157Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0337 5.3335C14.4724 5.33363 15.6958 6.39728 15.8996 7.80745L16.5103 12.4442H24.1483C25.5032 12.4442 26.6066 13.5444 26.6066 14.883C26.6065 15.2533 26.4989 15.6002 26.3071 15.8869C26.5347 16.3169 26.6665 16.8067 26.6665 17.3322C26.6665 19.8659 24.9396 22.0534 22.4816 22.6629L20.5155 23.1408L20.1795 24.3595C19.8078 25.71 18.5605 26.6668 17.1457 26.6668H12.4699C10.7912 26.6668 9.42432 25.3036 9.42432 23.6304V21.5158L8.80062 21.1929C7.4819 20.5117 6.6667 19.1613 6.6665 17.6916V8.67985C6.6665 6.83951 8.16501 5.33379 10.0233 5.3335H13.0337ZM9.84229 6.91943C8.94497 7.00947 8.24984 7.76092 8.24984 8.67985V17.6785C8.24984 18.563 8.74102 19.3761 9.53239 19.7944L10.3592 20.2241C10.7549 20.4392 11.0194 20.8585 11.0194 21.3127V23.6434C11.0197 24.4438 11.6785 25.1003 12.4816 25.1004H17.1587C17.8539 25.1002 18.4776 24.6343 18.6574 23.9533L19.173 22.077C19.2091 21.9337 19.3287 21.8146 19.4725 21.7788L22.1222 21.133C23.8728 20.7027 25.1079 19.1366 25.1079 17.3439C25.1076 16.5196 24.4363 15.8506 23.6092 15.8504H15.7915C15.5517 15.8504 15.3601 15.6712 15.3241 15.4442L15.2876 15.1812H24.7238C24.8915 15.1812 25.023 15.05 25.0233 14.883C25.0233 14.4049 24.6276 14.0223 24.16 14.0223H15.8748C15.4433 14.0221 15.0712 13.6985 15.0233 13.2684L14.341 8.0223C14.2451 7.37692 13.7049 6.89861 13.0454 6.8986H10.0363L9.84229 6.91943Z"
          fill="currentColor"
        />
        <path
          d="M26.5791 10.7418C26.7481 10.9113 26.9654 11 27.1988 11H27.2631C27.5126 10.9839 27.746 10.8548 27.8989 10.6531L31.8259 5.40088C32.1156 5.01362 32.0351 4.465 31.6489 4.17456C31.2626 3.88411 30.7154 3.96479 30.4257 4.35205L27.1022 8.79746L25.4847 7.17582C25.1467 6.83696 24.5915 6.83696 24.2535 7.17582C23.9155 7.51467 23.9155 8.07135 24.2535 8.4102L26.5791 10.7418Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1433_13289">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FlushInactiveIcon;
